import TransactionDetailsInstallerPosition from "../../../entities/checkout/transaction/TransactionDetailsInstallerPosition";
import { ITransactionDetailsInstallerPosition } from "../../../entities/checkout/transaction/types";
import { IManhattanFactory } from "../../manhattan/types";

export const TransactionDetailsInstallerPositionFactory: IManhattanFactory = class TransactionDetailsInstallerPositionFactory {

  static create(installerPosition: ITransactionDetailsInstallerPosition) {
    return new TransactionDetailsInstallerPosition(
      installerPosition.name,
      installerPosition.lastKnownLatitude,
      installerPosition.lastKnownLongitude,
      installerPosition.saLatitude,
      installerPosition.saLongitude,
      installerPosition.accessible,
    );
  }

};
